import { Box, Typography } from '@mui/material';
import { Check, Circle, ShieldCheck } from 'lucide-react';
import { useIntl } from 'react-intl';
import type { ReplanningStageProgress } from './useReplanningProgress';

interface ReplanningStageTasksProps {
    stage: ReplanningStageProgress | undefined;
}

export default function ReplanningStageTasks({
    stage,
}: ReplanningStageTasksProps) {
    const intl = useIntl();
    if (!stage) {
        return null;
    }

    return (
        <Box px={1.5} pb={1} data-testid="replanning-stage-tasks">
            {stage.tasks.map((task) => {
                const color = task.done ? 'success.main' : 'warning.main';
                const Icon = task.isSignOff
                    ? ShieldCheck
                    : task.done
                      ? Check
                      : Circle;
                return (
                    <Box
                        key={task.labelId}
                        display="flex"
                        alignItems="center"
                        gap={0.75}
                        py={0.15}
                    >
                        <Box
                            component={Icon}
                            aria-hidden
                            size={11}
                            sx={{ color, flexShrink: 0 }}
                        />
                        <Typography
                            fontSize={11.5}
                            color={task.done ? 'text.secondary' : color}
                        >
                            {intl.formatMessage({ id: task.labelId })}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
}
